import { LocationDescriptor } from 'history';

import { IntegrationType } from 'src/generated/mloop-graphql';

/**
 * Return type for all the hooks in this file
 */
export type ReturnType = {
  isOnboardingRequired: boolean;
  onboardingRedirectParams: LocationDescriptor<LocationState>;
};

/**
 * Integration Type Enum for grant access page
 * Note: **IMP** If you add a new integration type, please update the below DirectoryEmployeeIntegrationTypes array
 */
export type DirectoryEmployeeIntegrationType =
  | IntegrationType.GoogleEmployee
  | IntegrationType.MicrosoftEmployee
  | IntegrationType.MicrosoftCustomEmployee
  | IntegrationType.MicrosoftGccHighEmployee
  | IntegrationType.MicrosoftServiceUserEmployee;

export const DirectoryEmployeeIntegrationTypes: DirectoryEmployeeIntegrationType[] = [
  IntegrationType.GoogleEmployee,
  IntegrationType.MicrosoftEmployee,
  IntegrationType.MicrosoftCustomEmployee,
  IntegrationType.MicrosoftGccHighEmployee,
  IntegrationType.MicrosoftServiceUserEmployee,
];

export type MicrosoftEmployeeIntegrationType =
  | IntegrationType.MicrosoftEmployee
  | IntegrationType.MicrosoftGccHighEmployee
  | IntegrationType.MicrosoftCustomEmployee
  | IntegrationType.MicrosoftServiceUserEmployee;

export const EmailOnlyDirectoryIntegrationTypes: DirectoryEmployeeIntegrationType[] = [
  IntegrationType.GoogleEmployee,
  IntegrationType.MicrosoftServiceUserEmployee,
];

export const EmailAndCalendarDirectoryIntegrationTypes: DirectoryEmployeeIntegrationType[] = [
  IntegrationType.MicrosoftEmployee,
  IntegrationType.MicrosoftGccHighEmployee,
  IntegrationType.MicrosoftCustomEmployee,
];

/**
 * LocationState type for LocationDescriptor
 */
export type LocationState = {
  redirectUrl: string;
};
